import { render, staticRenderFns } from "./ModelSummary.vue?vue&type=template&id=1894df8e&"
import script from "./ModelSummary.vue?vue&type=script&lang=js&"
export * from "./ModelSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/declan/code/fourpointzero/portal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VImg})
